export default __webpack_public_path__ + "static/media/finalize-batch.a2401186.svg";